import '../sass/app.scss';
import AOS from "aos";
// import ‘aos/dist/aos.css’;
//import 'alpinejs';
import { navbarReady, paymentLinksReady } from './navbar';
// import { glideReady } from './glide';
import { accordionReady } from './accordion';
import { vertTabReady } from './vertical-tab';
import { approachProcessChartReady } from './approach-process-chart';
import { contactSetup, contactReady } from './contact';
import { teamDetailsSteup } from './team';
import { teamGridSetup } from './team-grid';
import { sideBanner } from './side-banner';
import { modalSetting } from './modal';
// import { dropdownSetup } from './dropdown-menu'
import { scrollToTopSetup } from './scroll-to-top'
// import { cookieSetting } from './cookieSetting';
// import { mapSetup } from './location-map';

import { leadershipSetup } from './leadership';
import { slideCarouselSetup } from './slideCarousel';
import { newsSliderSetup } from './newsSlider';

// cookieSetting();

contactSetup();
// NOTE: contactSetup() function must come before navbarReady();
//       contactSetup() search and prepare elements ready for navbarReady().
teamDetailsSteup();
teamGridSetup();
navbarReady();
paymentLinksReady();
contactReady();

//glideReady();
accordionReady();
vertTabReady();
approachProcessChartReady();

sideBanner();
modalSetting();
// dropdownSetup();
scrollToTopSetup();
leadershipSetup();
slideCarouselSetup();
newsSliderSetup();

// mapSetup();

AOS.init();